import React, { FC } from "react";
import { styled } from "@mui/material/styles";
import { TableRowProps } from "@mui/material/TableRow";

import { TableRow } from "../../UI/TableRow";
import { COLOR_WHITE } from "../../constants/styles";

export interface IProps {
  isDragging?: boolean;
  isLoading?: boolean;
}

const StyledTableRow = styled<any>(TableRow)(({ theme, isDragging, isLoading }) => ({
  backgroundColor: COLOR_WHITE,
  borderTop: isDragging ? `1px solid ${theme.palette.divider}` : 0,
  boxShadow: isDragging ? theme.shadows[8] : "none",
  opacity: isLoading ? 0.5 : 1,
  pointerEvents: isLoading ? "none" : "initial",
}));

export const EnhancedTableRow: FC<IProps & TableRowProps> = React.forwardRef((props, ref) => (
  <StyledTableRow {...props} className={props.className} ref={ref} />
));

EnhancedTableRow.defaultProps = {
  isLoading: false,
};
